export default "__VITE_ASSET__d8d6b14b__"